import TaxiCorporationCargoTaxiContractListRequest, {
  TaxiCorporationCargoTaxiContractListRequestQueryParams as TaxiCorporationCargoTaxiContractListRequestQueryParams,
} from "./taxi-corporation-cargo-taxi-contract-list.request";

const createQueryParams = (
  params: TaxiCorporationCargoTaxiContractListRequestQueryParams,
): TaxiCorporationCargoTaxiContractListRequest => {
  return {
    taxiCorporationUuid: params.taxiCorporationUuid,
  };
};

const taxiCorporationCargoTaxiContractListRequestFactory = {
  createQueryParams,
};

export default taxiCorporationCargoTaxiContractListRequestFactory;
